import {message} from "antd";
import {useNavigate} from "react-router-dom";
import {useDeleteStoreServiceApi} from "../../../../react-query-hooks/store/services/delete-store-service";

export function useDeleteStoreServiceHook(storeServiceId: number) {
  const deleteStoreServiceMutation = useDeleteStoreServiceApi();
  const navigate = useNavigate();
  function deleteStoreService(): Promise<unknown> {
    return new Promise((resolve, reject) => {
      resolve(
        deleteStoreServiceMutation.mutateAsync(
          {storeServiceId, currentPage: 1},
          {
            onSuccess() {
              message.success("The selected service has been deleted successfully");
              navigate("/products");
            },
          }
        )
      );
    }).catch(() => message.error("Failed to delete"));
  }

  return {
    deleteStoreService,
  };
}
